import { defineMessages } from 'react-intl-next';

export const messages: {
	groupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	groupLabel: {
		id: 'search-page.app-filter-sidebar.group',
		defaultMessage: 'Filter search by app',
		description: 'aria label for the group of product filters',
	},
});
